import { createAction } from 'redux-actions';
import { createSuccessAction, createFailureAction } from 'utilities/request';

export const requestResources = createAction('REQUEST/RESOURCES');
export const requestResourcesSuccess = createSuccessAction(requestResources);
export const requestResourcesFailure = createFailureAction(requestResources);

export const requestResourcesFaq = createAction('REQUEST/RESOURCES_FAQ');
export const requestResourcesFaqSuccess = createSuccessAction(requestResourcesFaq);
export const requestResourcesFaqFailure = createFailureAction(requestResourcesFaq);

export const resourcesInitialize = createAction('RESOURCES/INITIALIZE');
export const resourcesInitializeComplete = createAction('RESOURCES/INITIALIZE_COMPLETE');

export const requestGetResourceImage = createAction('REQUEST/GET_RESOURCE_IMAGE');
export const requestGetResourceImageSuccess = createSuccessAction(requestGetResourceImage);
export const requestGetResourceImageFailure = createFailureAction(requestGetResourceImage);

export const requestGetResourceFile = createAction('REQUEST/GET_RESOURCE_FILE');
export const requestGetResourceFileSuccess = createSuccessAction(requestGetResourceFile);
export const requestGetResourceFileFailure = createFailureAction(requestGetResourceFile);

export const resourcesLoadData = createAction('RESOURCES/LOAD_DATA');
export const resourcesLoadDataSuccess = createSuccessAction(resourcesLoadData);
export const resourcesLoadDataFailure = createFailureAction(resourcesLoadData);

export const resourcesChangeStatuses = createAction('RESOURCES/CHANGE_STATUSES');
export const resourcesChangeStatusesComplete = createAction('RESOURCES/CHANGE_STATUSES_COMPLETE');

export const requestPutPatientsStatuses = createAction('REQUEST/PUT_PATIENTS_STATUSES');
export const requestPutPatientsStatusesSuccess = createSuccessAction(requestPutPatientsStatuses);
export const requestPutPatientsStatusesFailure = createFailureAction(requestPutPatientsStatuses);

export const resourcesResetFiles = createAction('RESOURCES/RESET_FILES');
export const resourcesOpenPdf = createAction('RESOURCES/OPEN_PDF');
export const resourcesLikeResource = createAction('RESOURCES/LIKE_RESOURCE');
export const resourcesReadResource = createAction('RESOURCES/READ_RESOURCE');
export const resourcesSetStatuses = createAction('RESOURCES/SET_STATUSES');

export const requestGetPatientsResourcesStatuses = createAction(
  'REQUEST/GET_PATIENTS_RESOURCES_STATUSES',
);
export const requestGetPatientsResourcesStatusesSuccess = createSuccessAction(
  requestGetPatientsResourcesStatuses,
);
export const requestGetPatientsResourcesStatusesFailure = createFailureAction(
  requestGetPatientsResourcesStatuses,
);
